(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tw-header-search"] && !Shopify.designMode) return;
  try {
    function twSearchDismiss(event){const box=event.target.closest('.tw-header-search');if(!box)return;if(event.type==='keydown'&&event.key==='Escape'){box.setAttribute('data-dismissed','');box.querySelector('input[type="search"]').blur();}else if(event.type==='focusin'||event.type==='input'){box.removeAttribute('data-dismissed');}}
document.querySelectorAll('.tw-header-search').forEach(box=>{
 box.addEventListener('focusin',()=>box.setAttribute('data-discovery-open',''));
 box.addEventListener('keydown',event=>{if(event.key==='Escape')box.removeAttribute('data-discovery-open');});
 document.addEventListener('pointerdown',event=>{if(!box.contains(event.target))box.removeAttribute('data-discovery-open');});
 box.addEventListener('focusout',()=>setTimeout(()=>{if(!box.contains(document.activeElement))box.removeAttribute('data-discovery-open');},180));
});
document.addEventListener('keydown',twSearchDismiss);document.addEventListener('focusin',twSearchDismiss);document.addEventListener('input',twSearchDismiss);
  } catch(e) { console.error(e); }
})();

})();
